/* tslint:disable */
/* eslint-disable */
/**
 * WSK APIドキュメント
 *  WSK APIドキュメント  ## レスポンス形式 - result     - **status**：     - **message**：     - **system_date**：     - **pageno**： - data     - list         - **datacount**：         - **maxcount**：         - **list**：   ### result.status - **success**：正常終了 - **error**：入力エラー、権限エラー - **warning**：警告で、通知する必要のあるメッセージがある - **info**：正常処理で、通知する必要のあるメッセージがある  
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RenewalOrgItem
 */
export interface RenewalOrgItem {
    /**
     * 
     * @type {number}
     * @memberof RenewalOrgItem
     */
    companyId: number | null;
    /**
     * 
     * @type {number}
     * @memberof RenewalOrgItem
     */
    centerId: number | null;
    /**
     * 
     * @type {string}
     * @memberof RenewalOrgItem
     */
    orgCenterId: string | null;
    /**
     * 
     * @type {string}
     * @memberof RenewalOrgItem
     */
    orgItemCode: string | null;
    /**
     * 
     * @type {string}
     * @memberof RenewalOrgItem
     */
    itemName: string | null;
    /**
     * 
     * @type {Date}
     * @memberof RenewalOrgItem
     */
    startDate: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof RenewalOrgItem
     */
    endDate: Date | null;
    /**
     * 
     * @type {number}
     * @memberof RenewalOrgItem
     */
    renewalNumber: number | null;
    /**
     * 
     * @type {Date}
     * @memberof RenewalOrgItem
     */
    renewalStartDate: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof RenewalOrgItem
     */
    renewalEndDate: Date | null;
}

/**
 * Check if a given object implements the RenewalOrgItem interface.
 */
export function instanceOfRenewalOrgItem(value: object): value is RenewalOrgItem {
    if (!('companyId' in value) || value['companyId'] === undefined) return false;
    if (!('centerId' in value) || value['centerId'] === undefined) return false;
    if (!('orgCenterId' in value) || value['orgCenterId'] === undefined) return false;
    if (!('orgItemCode' in value) || value['orgItemCode'] === undefined) return false;
    if (!('itemName' in value) || value['itemName'] === undefined) return false;
    if (!('startDate' in value) || value['startDate'] === undefined) return false;
    if (!('endDate' in value) || value['endDate'] === undefined) return false;
    if (!('renewalNumber' in value) || value['renewalNumber'] === undefined) return false;
    if (!('renewalStartDate' in value) || value['renewalStartDate'] === undefined) return false;
    if (!('renewalEndDate' in value) || value['renewalEndDate'] === undefined) return false;
    return true;
}

export function RenewalOrgItemFromJSON(json: any): RenewalOrgItem {
    return RenewalOrgItemFromJSONTyped(json, false);
}

export function RenewalOrgItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): RenewalOrgItem {
    if (json == null) {
        return json;
    }
    return {
        
        'companyId': json['company_id'],
        'centerId': json['center_id'],
        'orgCenterId': json['org_center_id'],
        'orgItemCode': json['org_item_code'],
        'itemName': json['item_name'],
        'startDate': (json['start_date'] == null ? null : new Date(json['start_date'])),
        'endDate': (json['end_date'] == null ? null : new Date(json['end_date'])),
        'renewalNumber': json['renewal_number'],
        'renewalStartDate': (json['renewal_start_date'] == null ? null : new Date(json['renewal_start_date'])),
        'renewalEndDate': (json['renewal_end_date'] == null ? null : new Date(json['renewal_end_date'])),
    };
}

export function RenewalOrgItemToJSON(json: any): RenewalOrgItem {
    return RenewalOrgItemToJSONTyped(json, false);
}

export function RenewalOrgItemToJSONTyped(value?: RenewalOrgItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'company_id': value['companyId'],
        'center_id': value['centerId'],
        'org_center_id': value['orgCenterId'],
        'org_item_code': value['orgItemCode'],
        'item_name': value['itemName'],
        'start_date': value['startDate'] == null ? value['startDate'] : value['startDate'].toISOString(),
        'end_date': value['endDate'] == null ? value['endDate'] : value['endDate'].toISOString(),
        'renewal_number': value['renewalNumber'],
        'renewal_start_date': value['renewalStartDate'] == null ? value['renewalStartDate'] : value['renewalStartDate'].toISOString(),
        'renewal_end_date': value['renewalEndDate'] == null ? value['renewalEndDate'] : value['renewalEndDate'].toISOString(),
    };
}

